import { Component, Prop, h } from '@stencil/core';

import { BrowserUtils } from '../../../utils/utils.browser';
import { isLucidTheme } from '../../../utils/utils.theme';

@Component({
  tag: 'congratulation-certificate-message',
  styleUrl: 'congratulation-certificate-message.css',
})
export class CongratulationCertificateMessage {
  @Prop() consumer: string = '';
  @Prop() dealer: string = '';
  @Prop() vehicle: string = '';
  @Prop() vehicleImageLocation: string = '';
  @Prop() whenReviewClicked: (evt: Event) => void = () => {};
  @Prop() theme: string = '';
  @Prop() showKelleyBuysYourCar: boolean = false;
  @Prop() zip: string | number = '';
  @Prop() email: string = '';
  @Prop() offerId: string = '';

  hasDealerInterest() {
    return this.dealer.length > 0;
  }

  onReviewClick(evt: Event) {
    evt.preventDefault();
    this.whenReviewClicked(evt);
  }

  render() {
    const { zip, email, offerId } = this;

    const subHeaderContainerClass = {
      'leading-6': true,
      invisible: this.showKelleyBuysYourCar || isLucidTheme(this.theme),
    };
    return (
      <div class="text-center mdLrg:text-left">
        <div class="font-extrabold font-montserrat text-4xl mdLrg:mb-4">Congratulations, {this.consumer}!</div>
        <div class={subHeaderContainerClass}>
          {this.hasDealerInterest() ? (
            <div class="flex mdLrg:flex-row flex-col">
              <span>{this.dealer}</span> <span>&nbsp;is interested in your</span>
            </div>
          ) : (
            <span class="mt-1">Participating Dealers are interested in your</span>
          )}
        </div>
        <div class="font-bold leading-8">{this.vehicle}</div>
        <div class="leading-4 pb-4 mdLrg:pb-0">
          {/* todo, this should be a text styled button */}
          <a class="no-underline" href="#" onClick={(evt) => this.onReviewClick(evt)}>
            Review vehicle details
          </a>
        </div>
        <offer-short-description shouldDisplay={!BrowserUtils.IS_MOBILE} offerId={offerId} email={email} zipCode={zip} />
        {this.vehicleImageLocation && (
          <div>
            <img class="w-80" src={this.vehicleImageLocation}></img>
          </div>
        )}
      </div>
    );
  }
}
